import React from 'react';
import DonateItemPresenter from "./DonateItemPresenter";
import {Typography} from "antd";

function ExpansionUaz469() {
  return (
    <DonateItemPresenter
      itemName={"UAZ 469"}
      images={[
        "expansionuaz/green",
        "expansionuaz/black",
        "expansionuaz/lightgreen",
      ]}
      trunk={"300 (10 x 30)"}
      seats={"4"}
      insurance={"Sim, consulte a seção de seguros para mais informações"}
      price={<Typography.Title code>R$ 35,00</Typography.Title>}
    />
  );
}

export default ExpansionUaz469;